import { Flex, IconButton, Menu, MenuButton, MenuItem, MenuList } from "@chakra-ui/react";
import { useContext } from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { LuPenLine } from "react-icons/lu";

import {
  DirectMessagesIcon,
  ECashIcon,
  GamesIcon,
  MarketsIcon,
  NotesIcon,
  PlusCircleIcon,
  WalletIcon,
} from "../../icons";
import useRootPadding from "../../../hooks/use-root-padding";
import { PostModalContext } from "../../../providers/route/post-modal-provider";

export default function MobileBottomNav() {
  useRootPadding({ bottom: "var(--chakra-sizes-14)" });
  const { openModal } = useContext(PostModalContext);
  const navigate = useNavigate();

  return (
    <Flex
      gap="2"
      p="2"
      borderTopWidth={1}
      hideFrom="md"
      bg="var(--chakra-colors-chakra-body-bg)"
      position="fixed"
      bottom="var(--safe-bottom)"
      left="0"
      right="0"
      zIndex="modal"
    >
      <IconButton
        as={RouterLink}
        icon={<DirectMessagesIcon boxSize={6} />}
        aria-label="Messages"
        flexGrow="1"
        size="md"
        to="/messages"
      />
      <IconButton as={RouterLink} icon={<NotesIcon boxSize={6} />} aria-label="Feed" flexGrow="1" size="md" to="/feed" />
      <Menu placement="top" isLazy>
        <MenuButton
          as={IconButton}
          icon={<PlusCircleIcon boxSize={7} />}
          aria-label="Quick actions"
          colorScheme="primary"
          variant="solid"
          borderRadius="full"
          size="md"
        />
        <MenuList minW="0" w="200px">
          <MenuItem icon={<NotesIcon boxSize={5} />} onClick={() => openModal()}>
            New post
          </MenuItem>
          <MenuItem icon={<LuPenLine size={20} />} onClick={() => navigate("/messages")}>
            Message
          </MenuItem>
          <MenuItem icon={<ECashIcon boxSize={5} />} onClick={() => navigate("/wallet/pay/lightning")}>
            Send lits
          </MenuItem>
          <MenuItem icon={<WalletIcon boxSize={5} />} onClick={() => navigate("/wallet/receive")}>
            Receive lits
          </MenuItem>
          <MenuItem icon={<GamesIcon boxSize={5} />} onClick={() => navigate("/games")}>
            Play a game
          </MenuItem>
        </MenuList>
      </Menu>
      <IconButton
        as={RouterLink}
        icon={<GamesIcon boxSize={6} />}
        aria-label="Games"
        flexGrow="1"
        size="md"
        to="/games"
      />
      <IconButton
        as={RouterLink}
        icon={<MarketsIcon boxSize={6} />}
        aria-label="Markets"
        flexGrow="1"
        size="md"
        to="/markets"
      />
    </Flex>
  );
}
